import * as React from "react"
import classNames from "classnames"
import {
  Badge as ReactBadge,
  BadgeProps as ReactBadgeProps
} from "react-bootstrap"

interface BadgeProps extends ReactBadgeProps {
  children?: any
  className?: string
  outline?: boolean
  disabled?: boolean
  leftIcon?: React.ReactElement
  rightIcon?: React.ReactElement
  leftIconClassName?: string
  rightIconClassName?: string
}

const Badge = (props: BadgeProps) => {
  const {
    children,
    className,
    outline,
    disabled,
    leftIcon,
    rightIcon,
    leftIconClassName,
    rightIconClassName,
    ...rest
  } = props

  const renderLeftIcon = leftIcon && (
    <div className={classNames(leftIconClassName, "badge-left-icon")}>
      {leftIcon}
    </div>
  )

  const renderRightIcon = rightIcon && (
    <div className={classNames(rightIconClassName, "badge-right-icon")}>
      {rightIcon}
    </div>
  )

  return (
    <ReactBadge
      {...rest}
      className={classNames(
        className,
        outline ? "badge-outline" : "",
        disabled ? "disabled" : ""
      )}
    >
      {renderLeftIcon}
      {children ? <div className="badge-text">{children}</div> : null}
      {renderRightIcon}
    </ReactBadge>
  )
}

export const LockBadge = (
  props: Exclude<
    BadgeProps,
    "outline" | "pill" | "leftIcon" | "rightIcon" | "children"
  >
) => {
  const { children, ...rest } = props

  return (
    <Badge
      {...rest}
      pill={true}
      outline={true}
      rightIcon={<i className="modus-icons">lock</i>}
      rightIconClassName="m-0"
    />
  )
}

export default Badge
